/* @flow */
import React from 'react';
import type { Node } from 'react';
import { SoldWrapper, SoldItem, SoldTitle, SoldImage, GradientDiv } from './styles';
import { soldFlat, soldFlat2x, soldFlat3x } from '../../routes/apart/images';

const SoldMark = (): Node => (
	<SoldWrapper>
		<SoldItem id="sold">
			<SoldTitle>Эта квартира уже продана</SoldTitle>
			<SoldImage>
				<img src={soldFlat} srcSet={`${soldFlat}, ${soldFlat2x} 2x, ${soldFlat3x} 3x`} alt="" />
				<GradientDiv />
			</SoldImage>
		</SoldItem>
	</SoldWrapper>
);

export default SoldMark;
